import UnitLogger from '@/util/UnitLogger';

export const rocketIntegrationLogger = new UnitLogger('rocketIntegration', true);
